export default {
  inserted(el, binding, vnode) {
    const frag = document.createRange().createContextualFragment(binding.value)
    el.replaceWith(frag)
  }
}
